(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/dialogs/confirm-payment.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/dialogs/confirm-payment.js'); 
'use strict';

const currency = svs.utils.format.Currency;

function confirmPayment(_ref) {
  let {
    next,
    cancel,
    accountBalance,
    isSyndicate,
    syndicate,
    price,
    title,
    messages = []
  } = _ref;
  let customer = 'Ditt';
  if (isSyndicate) {
    customer = svs.tur.pay.utils.format_text.addOwningGrammarApostrophe(syndicate.syndicateName || 'Laget');
  }
  messages.push("".concat(customer, " saldo: ").concat(currency(accountBalance), " kr"));
  const message = messages.map(text => ({
    type: svs.ui.dialog.message.TEXT,
    align: svs.ui.dialog.message.align.CENTER,
    text
  }));
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'games',
    title,
    message,
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        cancel();
      }
    }, {
      title: "Betala ".concat(price, " kr"),
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  }));
}
svs.tur.pay.dialogs.confirmPayment = confirmPayment;
 })(window);